import { render } from "./FormularioNovaRota.vue?vue&type=template&id=6b5fc18a"
import script from "./FormularioNovaRota.vue?vue&type=script&lang=js"
export * from "./FormularioNovaRota.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__